import { render, staticRenderFns } from "./TabParts.vue?vue&type=template&id=3b60d56c&scoped=true"
import script from "./TabParts.vue?vue&type=script&lang=ts"
export * from "./TabParts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60d56c",
  null
  
)

export default component.exports